import { http, formatURI } from './public'


export const assetsApi = {
    findDataPageList (params, page){
        let url = formatURI('/services/asset/data/findPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    findLogPageList(params, page){
        let url = formatURI('/services/asset/log/findPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    findWithdrawPageList(params, page){
        let url = formatURI('/services/asset/withdraw/findPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
}